import html2pdf from 'html2pdf.js';
import moment from "moment";
import sealImage from "../assets/img/seal.png";
import sealLogo from "../assets/img/sealLogo.png";

const getLetterContent = (driver, language) => {
  const currentDate = moment().format("MMMM DD, YYYY");
  const driverName = `${driver.firstName} ${driver.lastName}`;
  
  const content = {
    en: {
      title: "DRIVER REGISTRATION CONFIRMATION",
      dateLabel: "Date:",
      refLabel: "Ref No:",
      date: currentDate,
      to: "To Whom It May Concern",
      subject: "Subject: Driver Registration Confirmation",
      body1: `This letter confirms that ${driverName} (Mobile: ${driver.mobile}) is registered as a driver on the Donkey Drive platform as of the date of this letter.`,
      body2: "Registered Information:",
      details: [
        `Full Name: ${driverName}`,
        `Mobile Number: ${driver.mobile}`,
        `Email: ${driver.email || "N/A"}`,
        `Registration Date: ${moment(driver.createdAt).format("MMMM DD, YYYY")}`,
        driver.vehicleNumber ? `Vehicle Number: ${driver.vehicleNumber}` : null,
        driver.carType ? `Vehicle Type: ${driver.carType}` : null,
        driver.vehicleMake && driver.vehicleModel ? `Vehicle: ${driver.vehicleMake} ${driver.vehicleModel}` : null
      ].filter(Boolean),
      complianceTitle: "Document Status:",
      vehicleReg: "Vehicle Registration:",
      driversLicense: "Driver's License:",
      tinNumber: "TIN Number:",
      docStatus: "Document Status:",
      onFile: "On File",
      notOnFile: "Not on File",
      allDocsOnFile: "ALL DOCUMENTS ON FILE",
      partialDocs: "PARTIAL DOCUMENTATION",
      complianceComplete: "All required documents are on file as of the date of this letter.",
      compliancePending: "Some documents may still be pending submission or verification.",
      body4: "This letter is provided for informational purposes only and confirms the registration status as of the date indicated. Donkey Drive makes no representations or warranties regarding the driver's current activity, income, or creditworthiness.",
      body5: "For any additional information, please contact our office directly. This letter does not constitute a guarantee or endorsement of any kind.",
      disclaimer: "This is a computer-generated document for informational purposes only. Donkey Drive assumes no liability for the use of this document.",
      closing: "Sincerely,"
    },
    am: {
      title: "የሹፌር ምዝገባ ማረጋገጫ ደብዳቤ",
      dateLabel: "ቀን:",
      refLabel: "ማጣቀሻ ቁጥር:",
      date: currentDate,
      to: "ለሚመለከተው አካል",
      subject: "ጉዳይ፡ የሹፌር ምዝገባ ማረጋገጫ",
      body1: `ይህ ደብዳቤ ${driverName} (ስልክ: ${driver.mobile}) በዚህ ደብዳቤ ቀን ዶንኪ ድራይቭ ላይ እንደ ሹፌር የተመዘገበ መሆኑን ያረጋግጣል።`,
      body2: "የተመዘገበ መረጃ:",
      details: [
        `ሙሉ ስም: ${driverName}`,
        `ስልክ ቁጥር: ${driver.mobile}`,
        `ኢሜይል: ${driver.email || "የለም"}`,
        `የምዝገባ ቀን: ${moment(driver.createdAt).format("MMMM DD, YYYY")}`,
        driver.vehicleNumber ? `የተሽከርካሪ ቁጥር: ${driver.vehicleNumber}` : null,
        driver.carType ? `የተሽከርካሪ አይነት: ${driver.carType}` : null,
        driver.vehicleMake && driver.vehicleModel ? `ተሽከርካሪ: ${driver.vehicleMake} ${driver.vehicleModel}` : null
      ].filter(Boolean),
      complianceTitle: "የሰነድ ሁኔታ:",
      vehicleReg: "የተሽከርካሪ ምዝገባ:",
      driversLicense: "የመንጃ ፈቃድ:",
      tinNumber: "የግብር መለያ ቁጥር:",
      docStatus: "የሰነድ ሁኔታ:",
      onFile: "በመዝገብ ላይ",
      notOnFile: "በመዝገብ ላይ የለም",
      allDocsOnFile: "ሁሉም ሰነዶች በመዝገብ ላይ",
      partialDocs: "ከፊል ሰነዶች",
      complianceComplete: "ሁሉም የሚፈለጉ ሰነዶች በዚህ ደብዳቤ ቀን በመዝገብ ላይ አሉ።",
      compliancePending: "አንዳንድ ሰነዶች አሁንም ለማስረከብ ወይም ለማረጋገጥ በመጠባበቅ ላይ ሊሆኑ ይችላሉ።",
      body4: "ይህ ደብዳቤ ለመረጃ ዓላማ ብቻ የቀረበ ሲሆን የተጠቀሰውን ቀን ያለውን የምዝገባ ሁኔታ ያረጋግጣል። ዶንኪ ድራይቭ ስለ ሹፌሩ አሁን ያለው እንቅስቃሴ፣ ገቢ ወይም የብድር አቅም ምንም ዋስትና አይሰጥም።",
      body5: "ተጨማሪ መረጃ ለማግኘት በቀጥታ ቢሮአችንን ያግኙ። ይህ ደብዳቤ ምንም ዓይነት ዋስትና ወይም ድጋፍ አይደለም።",
      disclaimer: "ይህ በኮምፒውተር የተፈጠረ ሰነድ ሲሆን ለመረጃ ዓላማ ብቻ ነው። ዶንኪ ድራይቭ ለዚህ ሰነድ አጠቃቀም ምንም ሀላፊነት አይወስድም።",
      closing: "ከሰላምታ ጋር,"
    },
    om: {
      title: "XALAYAA MIRKANEESSAA GALMEE KONKOLAACHISAA",
      dateLabel: "Guyyaa:",
      refLabel: "Lakk. Wabii:",
      date: currentDate,
      to: "Nama Ilaallatu Hundaaf",
      subject: "Dhimma: Mirkaneessaa Galmee Konkolaachisaa",
      body1: `Xalayaan kun ${driverName} (Lakk. Bilbilaa: ${driver.mobile}) guyyaa xalayaa kanaa waltajjii Donkey Drive irratti akka konkolaachisaa galmaa'e mirkaneessa.`,
      body2: "Odeeffannoo Galmaa'e:",
      details: [
        `Maqaa Guutuu: ${driverName}`,
        `Lakkoofsa Bilbilaa: ${driver.mobile}`,
        `Imeelii: ${driver.email || "Hin jiru"}`,
        `Guyyaa Galmee: ${moment(driver.createdAt).format("MMMM DD, YYYY")}`,
        driver.vehicleNumber ? `Lakkoofsa Konkolaataa: ${driver.vehicleNumber}` : null,
        driver.carType ? `Gosa Konkolaataa: ${driver.carType}` : null,
        driver.vehicleMake && driver.vehicleModel ? `Konkolaataa: ${driver.vehicleMake} ${driver.vehicleModel}` : null
      ].filter(Boolean),
      complianceTitle: "Haala Sanadaa:",
      vehicleReg: "Galmee Konkolaataa:",
      driversLicense: "Waraqaa Konkolaachisaa:",
      tinNumber: "Lakkoofsa Gibira:",
      docStatus: "Haala Sanadaa:",
      onFile: "Galmee Keessa Jira",
      notOnFile: "Galmee Keessa Hin Jiru",
      allDocsOnFile: "SANADOONNI HUNDI GALMEE KEESSA JIRU",
      partialDocs: "SANADOONNI KUTAA",
      complianceComplete: "Sanadoonni barbaachisan hundi guyyaa xalayaa kanaa galmee keessa jiru.",
      compliancePending: "Sanadoonni tokko tokko ammallee dhiyeessuuf ykn mirkaneessuuf eegaa jiraachuu danda'u.",
      body4: "Xalayaan kun odeeffannoo kennuuf qofa kan kennamee fi haala galmee guyyaa agarsiifame mirkaneessa. Donkey Drive waa'ee sochii konkolaachisaa ammaa, galii ykn amanamummaa liqii kamiyyuu hin ibsu.",
      body5: "Odeeffannoo dabalataa argachuuf, waajjira keenya kallattiin quunnamaa. Xalayaan kun wabii ykn deeggarsa gosa kamiyyuu miti.",
      disclaimer: "Kun sanadaa kompiitaraan uumame odeeffannoo kennuuf qofa. Donkey Drive fayyadama sanada kanaaf itti gaafatamummaa kamiyyuu hin fudhatu.",
      closing: "Nagaa wajjin,"
    },
    ti: {
      title: "ደብዳበ መረጋገጺ ሾፈር",
      dateLabel: "ዕለት:",
      refLabel: "ቁጽሪ ማጣቀሲ:",
      date: currentDate,
      to: "ንዝምልከቶ ኣካል",
      subject: "ጉዳይ፡ መረጋገጺ ሾፈርን ኩነታት ምርግጋጽን",
      body1: `እዚ ደብዳበ ${driverName} (ተሌፎን: ${driver.mobile}) ኣብ መድረኽ ዶንኪ ድራይቭ ዝተመዝገበ ሾፈር ምዃኑ ንምርግጋጽ የገልግል።`,
      body2: "ዝርዝር ሾፈር:",
      details: [
        `ምሉእ ሽም: ${driverName}`,
        `ቁጽሪ ተሌፎን: ${driver.mobile}`,
        `ኢመይል: ${driver.email || "የለን"}`,
        `ዕለት ምዝገባ: ${moment(driver.createdAt).format("MMMM DD, YYYY")}`,
        driver.vehicleNumber ? `ቁጽሪ መኪና: ${driver.vehicleNumber}` : null,
        driver.carType ? `ዓይነት መኪና: ${driver.carType}` : null,
        driver.vehicleMake && driver.vehicleModel ? `መኪና: ${driver.vehicleMake} ${driver.vehicleModel}` : null
      ].filter(Boolean),
      complianceTitle: "ኩነታት ሰነዳት:",
      vehicleReg: "ምዝገባ መኪና:",
      driversLicense: "ፈቓድ ሾፈር:",
      tinNumber: "ቁጽሪ ግብሪ:",
      docStatus: "ኩነታት ሰነዳት:",
      onFile: "ኣብ መዝገብ ኣሎ",
      notOnFile: "ኣብ መዝገብ የለን",
      allDocsOnFile: "ኩሉ ሰነዳት ኣብ መዝገብ ኣሎ",
      partialDocs: "ክፋላዊ ሰነዳት",
      complianceComplete: "ኩሎም ዝድለዩ ሰነዳት ኣብዚ ደብዳበ ዕለት ኣብ መዝገብ ኣለዉ።",
      compliancePending: "ገለ ሰነዳት ክሳብ ሕጂ ንምቕራብ ወይ ንምርግጋጽ ኣብ ምጽባይ ክኾኑ ይኽእሉ።",
      body4: "እዚ ደብዳበ ንልቓሕ ምሕታት፣ መስርሕ ልቓሕን ካልኦት ፋይናንሳዊ ኣገልግሎታትን ሓዊሱ ንወግዓዊ ዕላማታት ተዋሂቡ ኣሎ።",
      body5: "ተወሳኺ ሓበሬታ ወይ መረጋገጺ እንተደሊኹም በጃኹም ክትረኽቡና።",
      disclaimer: "እዚ ብኮምፒውተር ዝተፈጠረ ሰነድ ኮይኑ ንሓበሬታ ዕላማ ጥራይ እዩ። ዶንኪ ድራይቭ ንኣጠቓቕማ ናይዚ ሰነድ ዝኾነ ሓላፍነት ኣይወስድን።",
      closing: "ምስ ሰላምታ,"
    },
    ar: {
      title: "خطاب التحقق من السائق",
      dateLabel: "التاريخ:",
      refLabel: "رقم المرجع:",
      date: currentDate,
      to: "إلى من يهمه الأمر",
      subject: "الموضوع: التحقق من السائق وتأكيد الحالة",
      body1: `تؤكد هذه الرسالة أن ${driverName} (الهاتف: ${driver.mobile}) سائق نشط مسجل على منصة دونكي درايف.`,
      body2: "تفاصيل السائق:",
      details: [
        `الاسم الكامل: ${driverName}`,
        `رقم الهاتف: ${driver.mobile}`,
        `البريد الإلكتروني: ${driver.email || "غير متوفر"}`,
        `تاريخ التسجيل: ${moment(driver.createdAt).format("MMMM DD, YYYY")}`,
        driver.vehicleNumber ? `رقم المركبة: ${driver.vehicleNumber}` : null,
        driver.carType ? `نوع المركبة: ${driver.carType}` : null,
        driver.vehicleMake && driver.vehicleModel ? `المركبة: ${driver.vehicleMake} ${driver.vehicleModel}` : null
      ].filter(Boolean),
      complianceTitle: "حالة الوثائق:",
      vehicleReg: "تسجيل المركبة:",
      driversLicense: "رخصة القيادة:",
      tinNumber: "رقم الضريبة:",
      docStatus: "حالة الوثائق:",
      onFile: "في الملف",
      notOnFile: "ليس في الملف",
      allDocsOnFile: "جميع الوثائق في الملف",
      partialDocs: "وثائق جزئية",
      complianceComplete: "جميع الوثائق المطلوبة متوفرة في الملف اعتباراً من تاريخ هذه الرسالة.",
      compliancePending: "قد تكون بعض الوثائق لا تزال في انتظار التقديم أو التحقق.",
      body4: "صدرت هذه الرسالة للأغراض الرسمية بما في ذلك على سبيل المثال لا الحصر طلبات الائتمان ومعالجة القروض والخدمات المالية الأخرى.",
      body5: "إذا كنت بحاجة إلى أي معلومات إضافية أو التحقق، فلا تتردد في الاتصال بنا.",
      disclaimer: "هذه وثيقة مُنشأة بواسطة الحاسوب لأغراض إعلامية فقط. دونكي درايف لا تتحمل أي مسؤولية عن استخدام هذه الوثيقة.",
      closing: "مع خالص التحيات،"
    }
  };
  
  return content[language] || content.en;
};

export const generateDriverLetter = async (driver, language, checkCompliance) => {
  // All languages are now supported with HTML2PDF
  const content = getLetterContent(driver, language);
  const compliance = checkCompliance(driver);
  
  // Generate unique letter number
  const letterNumber = `DL-${moment().format('YYYYMMDD')}-${driver.uid?.substring(0, 6) || Math.random().toString(36).substring(2, 8).toUpperCase()}`;
  
  // Create HTML template for the letter
  const htmlTemplate = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Ethiopic:wght@400;700&family=Noto+Sans+Arabic:wght@400;700&family=Roboto:wght@400;700&display=swap');
        
        body {
          font-family: ${language === 'am' || language === 'ti' ? "'Noto Sans Ethiopic', Arial, sans-serif" : language === 'ar' ? "'Noto Sans Arabic', Arial, sans-serif" : "'Roboto', Arial, sans-serif"};
          font-size: 12px;
          line-height: 1.4;
          color: #000;
          margin: 0;
          padding: 20px;
          direction: ${language === 'ar' ? 'rtl' : 'ltr'};
        }
        
        .header {
          text-align: center;
          margin-bottom: 30px;
          position: relative;
        }
        
        .logo {
          width: 120px;
          height: 120px;
          margin: 0 auto 10px;
        }
        
        .company-name {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        
        .company-info {
          font-size: 12px;
          color: #666;
          margin-bottom: 5px;
        }
        
        .divider {
          border-top: 1px solid #000;
          margin: 10px 0;
        }
        
        .title {
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
        }
        
        .date-ref {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        }
        
        .to {
          font-weight: bold;
          margin-bottom: 10px;
        }
        
        .subject {
          margin-bottom: 20px;
        }
        
        .content {
          margin-bottom: 15px;
          text-align: justify;
        }
        
        .section-title {
          font-weight: bold;
          margin: 20px 0 10px 0;
        }
        
        .details-list {
          margin-left: 20px;
        }
        
        .details-list li {
          margin-bottom: 5px;
        }
        
        .compliance-item {
          margin-bottom: 8px;
          padding-left: 20px;
        }
        
        .compliance-item.on-file {
          color: #2e7d32;
        }
        
        .compliance-item.not-on-file {
          color: #d32f2f;
        }
        
        .signature-section {
          margin-top: 15px;
          position: relative;
        }
        
        .closing {
          margin-left: 4px;
          margin-bottom: 5px;
        }
        
        .seal {
          width: 100px;
          height: 100px;
          margin-left: 0;
        }
        
        .footer {
          position: fixed;
          bottom: 20px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 10px;
          color: #666;
          margin-top: 40px;
        }
        
        @media print {
          body { margin: 0; padding: 15px; }
          .footer { position: absolute; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        ${sealLogo ? `<img src="${sealLogo}" alt="Logo" class="logo">` : ''}
        <div class="company-name">DONKEY DRIVE</div>
        <div class="company-info">Haset Information Technology PLC</div>
        <div class="company-info">Email: info@donkeydrive.io | Phone: 9260</div>
      </div>
      
      <div class="divider"></div>
      
      <div class="title">${content.title}</div>
      
      <div class="date-ref">
        <span>${content.dateLabel} ${content.date}</span>
        <span>${content.refLabel} ${letterNumber}</span>
      </div>
      
      <div class="to">${content.to}</div>
      
      <div class="subject">${content.subject}</div>
      
      <div class="content">${content.body1}</div>
      
      <div class="section-title">${content.body2}</div>
      <ul class="details-list">
        ${content.details.map(detail => `<li>${detail}</li>`).join('')}
      </ul>
      
      <div class="section-title">${content.complianceTitle}</div>
      <div class="compliance-item ${compliance.hasCar ? 'on-file' : 'not-on-file'}">
        - ${content.vehicleReg} ${compliance.hasCar ? content.onFile : content.notOnFile}
      </div>
      <div class="compliance-item ${compliance.hasLicense ? 'on-file' : 'not-on-file'}">
        - ${content.driversLicense} ${compliance.hasLicense ? content.onFile : content.notOnFile}
      </div>
      <div class="compliance-item ${compliance.hasTIN ? 'on-file' : 'not-on-file'}">
        - ${content.tinNumber} ${compliance.hasTIN ? content.onFile : content.notOnFile}
      </div>
      <div class="compliance-item ${compliance.isFullyCompliant ? 'on-file' : 'not-on-file'}">
        - ${content.docStatus} ${compliance.isFullyCompliant ? content.allDocsOnFile : content.partialDocs}
      </div>
      
      <div class="content">
        ${compliance.isFullyCompliant 
          ? content.complianceComplete
          : content.compliancePending}
      </div>
      
      <div class="content">${content.body4}</div>
      
      <div class="content">${content.body5}</div>
      
      <div class="signature-section">
        <div class="closing">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${content.closing}</div>
        ${sealImage ? `<img src="${sealImage}" alt="Seal" class="seal">` : '<div style="margin-left: 0; font-size: 10px; color: #666;">[STAMP]</div>'}
      </div>
      
    </body>
    </html>
  `;
  
  // Configure html2pdf options
  const options = {
    margin: 0.5,
    filename: `Driver_Letter_${driver.firstName}_${driver.lastName}_${moment().format("YYYYMMDD")}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { 
      scale: 2,
      useCORS: true,
      letterRendering: true
    },
    jsPDF: { 
      unit: 'in', 
      format: 'a4', 
      orientation: 'portrait'
    }
  };
  
  // Create a temporary element to hold the HTML
  const element = document.createElement('div');
  element.innerHTML = htmlTemplate;
  
  // Generate and download the PDF
  try {
    await html2pdf().set(options).from(element).save();
    // Return the ref number printed on the letter so the caller can log the
    // exact same identifier to the fraud-audit trail.
    return letterNumber;
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw new Error('Failed to generate PDF. Please try again.');
  }
};
